import { useCallback } from "react";
import { fetchQuery, useQueryLoader, useRelayEnvironment } from "react-relay";
import { WIDGET_TODO_OVERVIEW_PREVIEW_QUERY } from "./WidgetTodoOverviewPreview";
import { useFocusEffect } from "@react-navigation/native";
import { useDebouncedCallback } from "use-debounce";

import {
  WidgetTodoOverviewPreviewQuery,
  WidgetTodoOverviewPreviewQuery$variables,
} from "./__generated__/WidgetTodoOverviewPreviewQuery.graphql";
import { captureException } from "../../../../../common/sentry";

export function useWidgetTodoOverviewPreviewQuery({
  teamIds,
  categoryId,
  storecastId,
  displayMode = "MEDIUM",
}: {
  teamIds: string[];
  categoryId: string;
  storecastId: string;
  displayMode?: "MEDIUM" | "MEDIUM_GROUPED";
}) {
  const [previewQuery, loadPreview] =
    useQueryLoader<WidgetTodoOverviewPreviewQuery>(
      WIDGET_TODO_OVERVIEW_PREVIEW_QUERY
    );

  const environment = useRelayEnvironment();

  const loadPreviewQuery = useDebouncedCallback(
    async (
      newTeamIds: string[],
      displayMode: "MEDIUM" | "MEDIUM_GROUPED" | undefined
    ) => {
      try {
        const variables: WidgetTodoOverviewPreviewQuery$variables = {
          input: {
            categoryId,
            size: "TWO_X_FOUR" as const,
            teamIds: newTeamIds.length === 0 ? null : newTeamIds,
            displayMode: displayMode ?? "MEDIUM",
          },
          storecastId,
          first: 10,
        };
        await fetchQuery(
          environment,
          WIDGET_TODO_OVERVIEW_PREVIEW_QUERY,
          variables
        ).toPromise();
        loadPreview(variables, {
          fetchPolicy: "store-and-network",
        });
      } catch (e) {
        captureException(e);
        console.log("error: ", e);
      }
    },
    300
  );
  useFocusEffect(
    useCallback(() => {
      loadPreviewQuery(teamIds, displayMode);
    }, [teamIds, displayMode, loadPreviewQuery])
  );
  return previewQuery;
}
